"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Workflows API
 * Create and manage pipelines
 *
 * The version of the OpenAPI document: 1.2.0
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var EnumRunStatus;
(function (EnumRunStatus) {
    EnumRunStatus["Active"] = "active";
    EnumRunStatus["Submitted"] = "submitted";
    EnumRunStatus["Pending"] = "pending";
    EnumRunStatus["Backoff"] = "backoff";
    EnumRunStatus["Completed"] = "completed";
    EnumRunStatus["Failed"] = "failed";
    EnumRunStatus["Suspended"] = "suspended";
    EnumRunStatus["Archiving"] = "archiving";
    EnumRunStatus["Terminated"] = "terminated";
    EnumRunStatus["Terminating"] = "terminating";
})(EnumRunStatus = exports.EnumRunStatus || (exports.EnumRunStatus = {}));
function EnumRunStatusFromJSON(json) {
    return EnumRunStatusFromJSONTyped(json, false);
}
exports.EnumRunStatusFromJSON = EnumRunStatusFromJSON;
function EnumRunStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.EnumRunStatusFromJSONTyped = EnumRunStatusFromJSONTyped;
function EnumRunStatusToJSON(value) {
    return value;
}
exports.EnumRunStatusToJSON = EnumRunStatusToJSON;
